import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { push } from 'react-router-redux'

import { load, schemas } from 'api'
import { requireIAH } from 'auth'
import { Heading } from 'core'
import { applyHOCs, selectSlug, formatDateRange } from 'helpers'
import { page, pageLoadSelectors, PageHead } from 'page'
import { formWizardFactory } from 'form-wizard'
import { PageBlockRenderer } from 'core/components/PageBlockRenderer'

import { loadReservations, clearReservations } from './actions'
import { reservationsSelector } from './selectors'
import reserve from './reserve'
import assign from './assign'
import { get } from 'lodash'
import styles from './style.scss'
import { Section } from 'layout'

const DEFAULT_FOOTER_TEXT =
  'All prices listed are in US Dollars (USD). Please note that we cannot offer cancellations, transfers, or refunds on enrollments in courses or programs.'

const InstitutionReservationWizard = formWizardFactory({
  steps: [reserve, assign],
  getStepFormName: ({ props, step }) => {
    return `SESSION REGISTER INSTITUTION - ${get(
      props,
      'sessionSale.slug'
    )} - ${get(step, 'name')}`
  },
  completeAction: ({ sessionSale }) => push(`/sessions/${sessionSale.slug}`)
})

class InstitutionReservationContainer extends Component {
  componentDidMount () {
    this.props.loadReservations(this.props.sessionSale)
  }

  componentWillUnmount () {
    this.props.clearReservations()
  }

  renderCustomContent (content) {
    if (!content) return null
    return (
      <div
        className={styles.customContent}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    )
  }

  renderFooter (sessionSale) {
    const footerContent =
      sessionSale.reserve_page_footer_content || DEFAULT_FOOTER_TEXT
    return (
      <div className={styles.footer}>
        <div
          className={styles.footerContent}
          dangerouslySetInnerHTML={{ __html: footerContent }}
        />
      </div>
    )
  }

  render () {
    const { reservations, sessionSale } = this.props

    if (!reservations) {
      return null
    }

    const hasPageBlocks = sessionSale.registration_page_blocks?.length > 0
    const hasCustomContent = !!sessionSale.reserve_page_content

    return (
      <div className={styles.reservePage}>
        <PageHead title={`Register for ${sessionSale.title}`} />
        {!hasPageBlocks && !hasCustomContent && (
          <div className={styles.header}>
            <Heading size='h6' freight center noMargin>
              {sessionSale.title}
            </Heading>
            {sessionSale.advertised_start_date &&
              sessionSale.advertised_end_date && (
                <Heading size='h6' freight center noMargin>
                  {formatDateRange(
                    sessionSale.advertised_start_date,
                    sessionSale.advertised_end_date
                  )}
                </Heading>
            )}
          </div>
        )}

        {hasPageBlocks || hasCustomContent
          ? (
            <div className={styles.twoColumnLayout}>
              <div className={styles.contentColumn}>
                <Section>
                  {hasPageBlocks
                    ? (
                      <PageBlockRenderer
                        blocks={sessionSale.registration_page_blocks}
                        sessionSale={sessionSale}
                      />
                      )
                    : (
                        this.renderCustomContent(sessionSale.reserve_page_content)
                      )}
                </Section>
              </div>
              <div className={styles.paymentColumn}>
                <InstitutionReservationWizard
                  sessionSale={sessionSale}
                  reservations={reservations}
                />
              </div>
            </div>
            )
          : (
            <div className={styles.centeredLayout}>
              <InstitutionReservationWizard
                sessionSale={sessionSale}
                reservations={reservations}
              />
            </div>
            )}

        {this.renderFooter(sessionSale)}
      </div>
    )
  }
}

export default applyHOCs([
  connect(
    createStructuredSelector({
      reservations: reservationsSelector
    }),
    { loadReservations, clearReservations }
  ),
  page({
    layout: 'form',
    ...pageLoadSelectors('sessionSale'),
    noPageHead: true
  }),
  load({
    sessionSale: {
      urlSelector: (state, props) => {
        return `/v2/session_sales/slug/${props.slug}`
      },
      schema: schemas.sessionSale
    }
  }),
  selectSlug(),
  requireIAH
])(InstitutionReservationContainer)
